export const KAJIKAJY_PLANS = {
    essor: {
        id: "essor",
        androidPlanId: "standard",
        label: "Essor",
        level: 1,
        billingPeriod: "monthly",
        price: {
            amountMGA: 12990,
            currency: "MGA",
            displayMonthly: "12 990 Ar/mois"
        },
        headline: "Le plan pour enlever les plafonds de la version gratuite : clients, fournisseurs, transactions et articles de stock.",
        features: [
            "Clients et fournisseurs sans plafond",
            "Transactions et stock sans plafond",
            "Ventes, achats, paiements partiels et obligations",
            "Statistiques, PDF et suivi des performances",
            "Sauvegarde cloud avec restauration assistée"
        ]
    },
    excellence: {
        id: "excellence",
        androidPlanId: "premium",
        label: "Excellence",
        level: 2,
        billingPeriod: "monthly",
        price: {
            amountMGA: 26990,
            currency: "MGA",
            displayMonthly: "26 990 Ar/mois"
        },
        headline: "Le plan pour travailler sur plusieurs appareils et garder la restauration cloud incluse.",
        features: [
            "Tout Essor inclus",
            "Compte utilisable sur plusieurs appareils",
            "Restauration cloud incluse",
            "Continuité de travail entre les appareils",
            "Priorité sur les opérations sensibles"
        ]
    }
};
export const KAJIKAJY_PLAN_IDS = Object.keys(KAJIKAJY_PLANS);
export function isKajikajyPlanId(value) {
    return typeof value === "string" && value in KAJIKAJY_PLANS;
}
export function getKajikajyPlan(planId) {
    return KAJIKAJY_PLANS[planId];
}
export function formatMonthlyPrice(amountMGA) {
    return `${new Intl.NumberFormat("fr-MG").format(amountMGA)} Ar/mois`;
}
//# sourceMappingURL=plans.js.map